// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-page__header {
    max-width: 650px;
    width: 100%;
    margin: 20px auto;
    text-align: right;
}
`, "",{"version":3,"sources":["webpack://./client/pages/posts/views/PostView.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB","sourcesContent":[".post-page__header {\n    max-width: 650px;\n    width: 100%;\n    margin: 20px auto;\n    text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
